import "../../css/guest-selector.css"
import React, {Dispatch, FC, SetStateAction, useEffect, useState} from "react";
import Select, {Options} from "../../../../components/form/Select";
import {Guest, GuestResponse} from "../../../../types/Guests";

interface MyComponentProps {
    searchResults: GuestResponse | null
    setGuest: Dispatch<SetStateAction<Guest | undefined>>
    multipleGroups: boolean;
}

const MultiGuestSelector:FC<MyComponentProps> = ({ setGuest, searchResults, multipleGroups }) => {
    const [guestOptions, setGuestOptions] = useState<Options[]>([]);

    const handleSelectGuest = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const index = event.target.selectedIndex;
        const option = event.target.options[index];

        if (searchResults && searchResults.items.length > 1) {
            let selectedGuest = searchResults.items.find(r => parseInt(option.id) === r.id);
            setGuest(selectedGuest);
        }

    }

    useEffect(() => {

        if (multipleGroups) {

            const options:Options[] = [];

            searchResults?.items.forEach(r => {
                options.push({id: r.id ? r.id.toString() : "", value: `${r.firstName} ${r.lastName}`});
            });

            setGuestOptions(options);

        } else {
            setGuestOptions([]);
        }

    }, [multipleGroups, searchResults?.items]);

    return (
        <div className="rsvp__guestSelector">
            <form className="form__input">
                <h2>More than one invite was found</h2>
                <h2>Please select your name from the list</h2>
                <Select
                    name="guestSelector"
                    value={""}
                    onChange={handleSelectGuest}
                    options={guestOptions}
                    id={"guestSelector"}
                    title={""}
                />
            </form>
        </div>
    );
};

export default MultiGuestSelector;
